module.exports = __webpack_public_path__ + "img/delete-icon.fa1e8b89.svg";